import { Injectable } from '@angular/core';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class OnboardOrganizationService {

  constructor(private base: BaseService) { }

  viewServiceProvider(id) {
    return this.base.post('/api/service-provider-by-id',{id:id});
  }

  getListing(){
    return this.base.get('/api/service-provider-list');
  }

  updateOnboardOrg(data) {
    return this.base.post('/api/service-provider-update-status',data);
  }

   updateStatus(data) {
    return this.base.post('/api/service-provider-status-update',data);
  }

  


}
